var _path, _path2, _path3, _g, _path4, _g2, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummaryCo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96323 45.0664C6.09652 45.1128 6.23172 45.1353 6.3674 45.1353C6.86938 45.1353 7.33972 44.823 7.51567 44.3239C7.77505 43.5896 13.5907 27.0345 14.1354 18.3783H26.9514C27.0564 19.776 27.3301 21.4476 27.7003 23.2429H17.1386C16.4659 23.2429 15.9208 23.787 15.9208 24.4595C15.9208 25.1315 16.4659 25.6756 17.1386 25.6756H28.2373C30.1809 33.8347 33.5807 43.4268 33.7801 43.9877C34.0035 44.6199 34.6958 44.9452 35.3354 44.7268C35.9678 44.5012 36.2981 43.8061 36.0723 43.1734C36.0057 42.9842 29.3361 24.1659 29.3361 17.1622C29.3361 16.4897 28.792 15.9456 28.1188 15.9456H12.9583C12.2857 15.9456 11.741 16.4897 11.741 17.1622C11.741 24.9533 5.28578 43.33 5.21913 43.514C4.99523 44.1481 5.32845 44.8431 5.96323 45.0664Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4084 20.8108H32.8696C32.1965 20.8108 31.6519 21.3549 31.6519 22.0269C31.6519 22.6994 32.1965 23.2431 32.8696 23.2431H43.2314C43.3215 24.7174 43.5622 26.3809 43.8897 28.1081H35.5847C34.9116 28.1081 34.3674 28.6522 34.3674 29.3243C34.3674 29.9967 34.9116 30.5404 35.5847 30.5404H44.4003C45.8813 37.0953 48.2147 43.756 48.3581 44.1627C48.534 44.6613 49.0044 44.9736 49.5064 44.9736C49.6416 44.9736 49.7772 44.9511 49.9105 44.9051C50.5453 44.6805 50.8785 43.9869 50.6551 43.3527C50.6048 43.21 45.6257 29.0345 45.6257 22.0269C45.6257 21.3549 45.0816 20.8108 44.4084 20.8108Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_99",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 47,
    width: 56,
    height: 3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 47.5676H56V49.9999H0V47.5676Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_99)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7827 47.5676H1.21731C0.544169 47.5676 0 48.1118 0 48.7838C0 49.4563 0.544169 49.9999 1.21731 49.9999H54.7827C55.4554 49.9999 56 49.4563 56 48.7838C56 48.1118 55.4554 47.5676 54.7827 47.5676Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_99",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 0,
    width: 19,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.563 0H36.3988V13.0133H18.563V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_99)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2058 13.0133C20.434 13.0133 20.667 12.9491 20.8737 12.814C21.4327 12.4514 21.5899 11.7009 21.2356 11.139C21.216 11.1093 20.7931 10.4253 21.1163 9.75812C21.366 9.24369 22.4505 7.99498 27.1083 7.49875C31.7522 7.00444 34.6979 5.75525 35.8654 3.78471C36.7763 2.24909 36.2581 0.897394 36.1962 0.747951C35.9368 0.126708 35.2186 -0.163077 34.603 0.0931795C33.9821 0.35231 33.6897 1.0636 33.9467 1.68389C33.9491 1.68724 34.0536 2.0709 33.7707 2.54462C33.4284 3.1218 32.0706 4.52474 26.8514 5.08036C22.4338 5.5512 19.8352 6.74914 18.9027 8.74699C18.1873 10.2778 18.7555 11.8149 19.2047 12.4811C19.4377 12.8284 19.8184 13.0133 20.2058 13.0133Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.965 18.1527C38.174 18.1527 38.383 18.0957 38.5715 17.9697C39.1276 17.5946 39.2748 16.9212 38.8994 16.3641C38.9018 16.3593 39.2273 15.9829 40.8109 15.8143C42.9939 15.5815 44.3516 14.9674 44.9624 13.9352C45.381 13.2282 45.3311 12.4944 45.1432 12.0442C44.8838 11.4244 44.1632 11.1332 43.55 11.3899C43.0078 11.6155 42.7153 12.1879 42.8227 12.7425C42.6846 12.8709 42.1615 13.2239 40.554 13.3959C38.4621 13.6181 37.2041 14.2465 36.7045 15.3166C36.3027 16.1764 36.5501 17.0611 36.8829 17.5563C37.1326 17.9271 37.5488 18.1527 37.965 18.1527Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryCo2);
export default __webpack_public_path__ + "static/media/summary_co2.0ccf6cad6d6b472fc533bb00801d0696.svg";
export { ForwardRef as ReactComponent };